import { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import profileSettings from "../../../../redux/profile/actions";
import AchievementCard from "./achievementCard";
import { Row, Col } from "antd";
import AddNewAward from "./addNewAward";
import AddNewAchievement from "./addNewAchievement";
import AddNewPress from "./addNewPress";
import styles from "./style.module.scss";
import settingsActions from "../../../../redux/settings/actions";
function useOutsideAlerter(ref, func) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        func(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

const Achievements = () => {
  const { achievements = [], currentUser } = useSelector((state) => ({
    achievements: state.profile.achievements,
    currentUser: state.profile.currentUser,
  }));
  const [achievementHidden, setAchivementHidden] = useState(false);
  const [hiddenList, setHiddenList] = useState([]);
  const wrapperRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: profileSettings.GET_ALL_ACHIEVEMENTS,
    });
  }, []);

  useEffect(() => {
    setAchivementHidden(currentUser.achievementHidden);
  }, [currentUser.achievementHidden]);

  useEffect(() => {
    setHiddenList(achievements);
  }, [achievements]);

  const [addNewOptions, setShowAddNewOptions] = useState(false);
  const [showForm, setShowForm] = useState();
  useOutsideAlerter(wrapperRef, setShowAddNewOptions);

  const updateHiddenList = (music) => {
    const list = [...hiddenList];
    for (const i in list) {
      if (list[i].id === music.id) {
        list[i].hidden = !list[i].hidden;
        break;
      }
    }
    setHiddenList(list);
  };

  const save = () => {
    dispatch({
      type: settingsActions.HIDE_SHOW_ACHIEVEMENT,
      payload: {
        achievementHidden: achievementHidden,
        hiddenList: hiddenList,
      },
    });
  };

  return (
    <div className={styles.achievementContainer}>
      <div className={styles.genericButton}>
        <button className={styles.button} htmlType="submit" onClick={save}>
          Save
        </button>
      </div>
      <Row justify="space-between" align="top" className={styles.topContent}>
        <Col span={8} className={styles.showHide}>
          <div
            onClick={() => setAchivementHidden(!achievementHidden)}
            className={`${styles.select} ${
              !achievementHidden ? styles.selected : ""
            }`}
          />
          <div>Show/Hide on profile page</div>
        </Col>
      </Row>
      <div className={styles.plusButton}>
        <div style={{ width: 250 }} ref={wrapperRef}>
          <div
            className={showForm ? styles.button1 : styles.button}
            onClick={() => setShowAddNewOptions(true)}
          >
            +
          </div>
          {addNewOptions && (
            <div className={styles.options}>
              <div
                className={styles.option}
                onClick={() => {
                  setShowAddNewOptions(false);
                  setShowForm("Achievements");
                }}
              >
                Achievements
              </div>
              <div
                className={styles.option}
                onClick={() => {
                  setShowAddNewOptions(false);
                  setShowForm("Awards");
                }}
              >
                Awards
              </div>
              <div
                className={styles.option}
                onClick={() => {
                  setShowAddNewOptions(false);
                  setShowForm("Press");
                }}
              >
                Press
              </div>
            </div>
          )}
        </div>
      </div>
      {showForm === "Awards" && <AddNewAward close={() => setShowForm(null)} />}
      {showForm === "Achievements" && (
        <AddNewAchievement close={() => setShowForm(null)} />
      )}
      {showForm === "Press" && <AddNewPress close={() => setShowForm(null)} />}
      {achievements.map((achievement) => (
        <AchievementCard updateHiddenList={updateHiddenList} achievement={achievement} key={achievement.id} />
      ))}
    </div>
  );
};

export default Achievements;
